var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmsEcommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Progressive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-7 9 284 284",
    style: {
      enableBackground: "new -7 9 284 284"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#55A345;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#F2644B;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#F2644B;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#55A345;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.1,211.5H26.6c-3.5,0-6.3-2.8-6.3-6.3v-142c0-3.5,2.8-6.3,6.3-6.3h217.5c3.5,0,6.3,2.8,6.3,6.3v142 C250.3,208.7,247.5,211.5,244.1,211.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "172.5,251.8 101.5,251.8 111.7,211.2 162.4,211.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 71.1,
    y1: 251.8,
    x2: 203,
    y2: 251.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,117.7h61.1l-12.8,35.1c-0.5,1.3-1.8,2.2-3.2,2.2h-38.8c-1.7,0-3.2-1.3-3.4-3l-6.4-51.4h-13.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 177.4,
    cy: 174.1,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 140,
    cy: 174.1,
    r: 6.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.5,58.4c0.9,1.8,1.7,3.7,2.4,5.7c0.6,1.9,2.5,3.2,4.5,3.2h4.8c2.7,0,4.8,2.2,4.8,4.8v9.7 c0,2.7-2.2,4.8-4.8,4.8h-4.8c-2,0-3.9,1.2-4.5,3.2c-0.6,2-1.4,3.9-2.4,5.7c-0.9,1.8-0.5,4,1,5.5l3.4,3.4c1.9,1.9,1.9,5,0,6.8 L75,118c-1.9,1.9-5,1.9-6.8,0l-3.4-3.4c-1.4-1.4-3.7-1.9-5.5-1c-1.8,0.9-3.7,1.7-5.7,2.4c-1.9,0.6-3.2,2.5-3.2,4.5v4.8 c0,2.7-2.2,4.8-4.8,4.8h-9.7c-2.7,0-4.8-2.2-4.8-4.8v-4.8c0-2-1.2-3.9-3.2-4.5c-2-0.6-3.9-1.4-5.7-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.3,57.7c3.8,3.5,6.1,8.6,6.1,14.1c0,10.7-8.7,19.4-19.4,19.4c-5.9,0-11.2-2.6-14.7-6.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsEcommerce);
export default __webpack_public_path__ + "static/media/cms-ecommerce.872ab840d9c4ce91432de8a13959ac69.svg";
export { ForwardRef as ReactComponent };